import { useMutation, useQueryClient } from 'react-query';

import {
  updateScenarioFlexCapacitySettings,
  UpdateScenarioFlexCapacitySettingsOptions
} from 'RestAPIs/scenario';
import {
  deleteAdditionalCapacity,
  DeleteAdditionalCapacityOptions
} from 'RestAPIs/scenario-additional-capacity';

import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

export const queryKeys = {
  ADDITIONAL_CAPACITY: 'additionalCapacity',
  SCENARIO_FLEX_CAPACITY_SETTINGS: 'scenarioFlexCapacitySettings'
};

export const useUpdateFlexCapacitySettings = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (options: UpdateScenarioFlexCapacitySettingsOptions) =>
      updateScenarioFlexCapacitySettings(options),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([
          queryKeys.SCENARIO_FLEX_CAPACITY_SETTINGS
        ]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export const useDeleteAdditionalCapacity = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (options: DeleteAdditionalCapacityOptions) =>
      deleteAdditionalCapacity(options),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([queryKeys.ADDITIONAL_CAPACITY]);
        await queryClient.invalidateQueries([
          queryKeys.SCENARIO_FLEX_CAPACITY_SETTINGS
        ]);
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};
